export const numberInputFormatter = (e) => {
  e.target.value = e.target.value.replace(/[^0-9]/g, '');
};

export const positiveNumberInputFormatter = (e) => {
  e.target.value = e.target.value.replace(/[^0-9]/g, '');
  if (parseInt(e.target.value) <= 0) {
    e.target.value = '';
  }
};

export const floatInputFormatter = (e) => {
  let value = e.target.value;
  
  // 첫 번째 문자가 -인지 확인
  const isNegative = value.startsWith('-');
  
  // -를 제외하고 숫자와 점만 허용
  value = value.replace(/[^0-9.-]/g, '');
  
  // -는 맨 앞에만 허용
  if (isNegative) {
    value = '-' + value.replace(/-/g, '');
  } else {
    value = value.replace(/-/g, '');
  }
  
  // 소수점이 여러 개 있으면 첫 번째 것만 유지
  const parts = value.split('.');
  if (parts.length > 2) {
    value = parts[0] + '.' + parts.slice(1).join('');
  }
  
  e.target.value = value;
};

export const emailInputFormatter = (e) => {
  e.target.value = e.target.value.replace(/[^a-zA-Z0-9@._-]/g, '');
};

export const phoneNumberInputFormatter = (e) => {
  e.target.value = e.target.value.replace(/[^0-9]/g, '');
};

